import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, TextField, Button, Stack } from "@mui/material";
import BoxCodeAssociation from "./components/boxCodeAssociation/BoxCodeAssociation";
import SearchField from "../../components/searchField/SearchField";
import {
  codeGeneratorWS,
  getUnusedActivationCodeWS,
} from "./activationCodeApi";
import { isEmpty } from "../../utils/validation";
import { gestioneSnackbar } from "../../utils/common";

const ActivationCode = () => {
  const [associationName, setAssociationName] = useState("");

  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const refreshContent = () => {
    getUnusedActivationCodeWS()
      .then((res) => {
        setData(res);
        setFilteredData(res);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    refreshContent();
  }, []);

  useEffect(() => {
    if (search) {
      setFilteredData(
        data.filter((item) => {
          const name = item.name?.toLowerCase() || "";
          const code = item.code?.toLowerCase() || "";

          return (
            name.includes(search.toLowerCase()) ||
            code.includes(search.toLowerCase())
          );
        })
      );
    } else {
      setFilteredData(data);
    }
  }, [search]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isEmpty(associationName)) {
      return gestioneSnackbar(true, "Nome associazione obbligatorio", "error");
    }

    codeGeneratorWS({ name: associationName })
      .then((res) => {
        gestioneSnackbar(true, "CODICE: " + res.code, "success");
        refreshContent();
      })
      .catch((err) => gestioneSnackbar(true, err, "error"));
  };

  return (
    <Box>
      <Grid container spacing={4}>
        {/* Colonna di sinistra */}
        <Grid
          size={{ xs: 12, md: 6 }}
          sx={{ p: 2, maxHeight: `calc(100vh - 120px)` }}
        >
          <Stack gap={1}>
            <Typography variant="h6" gutterBottom>
              Genera il codice della nuova associazione
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                label="Nome dell'associazione"
                variant="outlined"
                fullWidth
                value={associationName}
                onChange={(e) => setAssociationName(e.target.value)}
                inputProps={{ maxLength: 50 }}
              />
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  width: 150,
                  background: "green",
                  alignSelf: "flex-end",
                }}
                type="submit"
              >
                Genera
              </Button>
            </form>
          </Stack>
        </Grid>

        {/* Colonna destra */}
        <Grid
          size={{ xs: 12, md: 6 }}
          sx={{ p: 2, maxHeight: `calc(100vh - 120px)` }}
        >
          <Stack gap={2}>
            <Typography variant="h5">Codici ancora da usare:</Typography>
            <SearchField setSearch={setSearch} />
            <Stack gap={1}>
              {!isEmpty(filteredData)
                ? filteredData.map((item, index) => (
                    <BoxCodeAssociation
                      key={index}
                      name={item.name}
                      code={item.code}
                    />
                  ))
                : null}
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ActivationCode;
